// extracted by mini-css-extract-plugin
export var card = "_8g-0";
export var failedIcon = "_8g-4";
export var failedIconBadge = "_8g-3";
export var icon = "_8g-1";
export var successIcon = "_8g-2";